"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = new (/** @class */ (function () {
    function EventLog() {
        var _this = this;
        this.keepMax = 50;
        this.eventLog = [];
        this.eventLogExtended = [];
        /**
         * Initialize the plugin.
         * @return {void}
         */
        this.init = function (options) {
            _this.keepMax = options.keepMax || _this.keepMax;
        };
        this.addToLog = function (event, base) {
            var props = {
                default: ['call_type', 'event_action', 'event_name', 'event_category', 'event_label', 'event_value', 'media_id'],
                view: ['call_type', 'event_category', 'media_id', 'page_url'],
            };
            var includeFields = event.call_type === 'view' ? props.view : props.default;
            var logData = includeFields.reduce(function (acc, prop) {
                var _a;
                if (event[prop] !== undefined) {
                    return __assign(__assign({}, acc), (_a = {}, _a[prop] = event[prop], _a));
                }
                return acc;
            }, {});
            if (Object.keys(logData).length === 0) {
                return;
            }
            _this.eventLog.push(logData);
            _this.eventLogExtended.push(__assign({}, event));
            base.info("'".concat(event.call_type, "' added to log"), logData);
            if (_this.eventLog.length > _this.keepMax) {
                _this.eventLog.shift();
                _this.eventLogExtended.shift();
            }
        };
        /**
         * Check if the last event is equal to the provided event name
         * @param eventName string event name
         * @param callType string view|link
         * @return {boolean}
         */
        this.isLastEvent = function (eventName, callType) {
            var lastEvent = _this.getLastEvent();
            if (!lastEvent) {
                return false;
            }
            return (!callType || lastEvent.call_type === callType) && lastEvent.event_name === eventName;
        };
        this.getLastEvent = function () { return _this.eventLog[_this.eventLog.length - 1] || false; };
        this.didEventOccurred = function (eventName, callType) {
            if (!eventName) {
                return false;
            }
            var events = _this.eventLog.filter(function (event) { return (!callType || event.call_type === callType) && event.event_name === eventName; });
            return !!events.length;
        };
    }
    return EventLog;
}()))();
